var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Toast',{attrs:{"type":"info-neutral","icon":"iconoir-warning-triangle"},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.$t('userSessionExpiredToast.title')))]},proxy:true}])},[_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.$t('userSessionExpiredToast.content')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }